import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import attachReportPackageReport from './attachReportPackageReport';
import controller from './attach-report-package-report-folder.controller';
import directive from './attach-report-package-report-folder.directive';


export default angular.module('app.components.reports.packageReports.attachReportPackageReportFolder', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
  attachReportPackageReport
])
  .directive('prAttachReportPackageReportFolder', directive)
  .controller('AttachReportPackageReportFolderController', controller)
  .name;

console.log('app.components.reports.packageReports.attachReportPackageReportFolder created');
